<template>
  <div class="dropdown" ref="dropdownBox" @click.stop.prevent>
    <div class="dropdown-title">
      <img
        src="@/assets/images/icons/search/back.png"
        class="back"
        @click.prevent="backDowndown"
        v-show="isShowBack"
      />
      <img
        src="@/assets/images/icons/search/close.png"
        class="close"
        @click.prevent="closeDowndown"
      />
    </div>

    <div
      class="dropdown-content"
      ref="dropdownContent"
      :style="
        'min-height:' +
          dropDownHeight.minHeight +
          'px;max-height:' +
          dropDownHeight.maxHeight +
          'px;height:' +
          dropDownHeight.height +
          'px'
      "
    >
      <iscroll-view
        class="scroll-view"
        :options="{
          disableTouch: true,
          momentum: false,
          mouseWheel: true,
          scrollbars: true,
          fadeScrollbars: false,
          interactiveScrollbars: false,
          snap: true
        }"
        ref="iscroll"
      >
        <Loader
          :loadType="1"
          v-show="productReadynew"
          class="black"
          style="top:0;"
        ></Loader>
        <div
          :class="$style.dropdownContentPadding"
          ref="autoModContent"
          key="autoModContent"
          v-show="!productReadynew"
        >
          <ul class="list">
            <li
              v-for="(item, index) in productList"
              :key="'ex-item-' + index"
              :data-index="index"
            >
              <div class="item">
                <a
                  href="#"
                  :_id="item.data.code"
                  @click.prevent="selectItem"
                  v-if="!item.leafs || item.leafs.length === 0"
                >
                  <span
                    class="item-code"
                    v-html="
                      highlight(
                        $options.filters.specialHSCodeValue(
                          item.data.code,
                          '(-)'
                        ),
                        highlightText,
                        true
                      )
                    "
                  ></span>
                  <span
                    class="item-name"
                    v-html="highlight(item.data.name, highlightText)"
                  ></span>
                </a>
                <a
                  href="#"
                  :_id="item.data.code"
                  class="item-parent"
                  @click.prevent
                  v-else
                >
                  <span
                    class="item-code"
                    v-html="
                      highlight(
                        $options.filters.specialHSCodeValue(
                          item.data.code,
                          '(-)'
                        ),
                        highlightText,
                        true
                      )
                    "
                  ></span>
                  <span
                    class="item-name"
                    v-html="highlight(item.data.name, highlightText)"
                  ></span>
                </a>
                <ul class="subitem" v-if="item.leafs && item.leafs.length > 0">
                  <li
                    v-for="(citem, cindex) in item.leafs"
                    :key="'ex-item-child' + cindex"
                  >
                    <a
                      href="#"
                      :_id="citem.data.code"
                      @click.prevent="selectItem"
                    >
                      <span
                        class="item-code"
                        v-html="
                          highlight(
                            $options.filters.specialHSCodeValue(
                              citem.data.code,
                              '<span class=grey>(-)</span>'
                            ),
                            highlightText,
                            true
                          )
                        "
                      ></span>
                      <span
                        class="item-name"
                        v-html="highlight(citem.data.name, highlightText)"
                      ></span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="ellipsis empty"
              key="ex-item--1"
              v-show="productList.length === 0 && value !== ''"
            >
              <i>{{ $t("query.empty") }}</i>
            </li>
          </ul>
          <div class="history" >
            <div class="title">{{ $t("query.dropdown.export.recent") }}</div>
            <ul class="list">
              <li v-for="(v, i) in historyList" :key="'history-pr-item-' + i">
                <a
                  href="#"
                  :_id="v.id"
                  v-if="!_.isEmpty(_.trim(v.id))"
                  :_level="v._level"
                  :_name="v.text"
                  @click.prevent="selectItem($event, 'history')"
                >
                  <span class="item-code">{{ v.id }}</span>
                  <span class="item-name">{{ v.text }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </iscroll-view>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";
import Loader from "@/components/layout/Loader";
const {
  mapState: mapDataState,
  mapGetters: mapDataGetters
} = createNamespacedHelpers("data");
const { mapState: mapSearchState } = createNamespacedHelpers("search");

export default {
  name: "ProductDropdown",
  components: { Loader },
  props: {
    countrycode: {
      type: [Number, String],
      default: null
    },
    value: {
      type: String,
      require: true
    },
    dropDownHeight: {
      type: Object
    }
  },
  data() {
    return {
      productList: [],
      highlightText: this.value,
      isShowBack: false,
      isAllowUpdateData: true,
      productReadynew: false
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.highlightText = newVal;
      this.getProductList(newVal);
    },
    productReady(newVal, oldVal) {
      // if (newVal) {
      //   this.productList = this.getTopProduct()();
      // }
    },
    productList(newVal, oldVal) {
      if (newVal && newVal.length > 0 && this.$parent.text !== "") {
        this.isShowBack = true;
      } else {
        this.isShowBack = false;
      }
    }
  },
  created() {
    if (this.value) {
      this.queryDebounce = this._.debounce(val => {
        this.getProductList(val);
      }, 120);
    }
  },
  computed: {
    ...mapDataState(["productReady", "rootParentCode"]),
    ...mapSearchState({
      historyList: state => state.history.products
    })
  },
  updated() {
    this.$nextTick(() => {
      try {
        this.updateContentHeight();
        this.refresh();
      } catch (e) {}
    });
  },
  methods: {
    findproductList(code, productList) {
      productList.forEach(el => {
        if ((productList.length && productList[0].id.indexOf(code) > -1) || (productList.length && productList[0].data.name.indexOf(code) > -1)) {
        
          // this.$emit("selectItem", el.id, el.data.name, null, false);
          this.productList = productList;
          if (this.productList.length === 1) {
            
            if(code.length==10 && code == this.productList[0].id){
        
              // this.$parent.setDefaultValue({
              //   id:this.productList[0].id,
              //   text:this.productList[0].data.name
              // })
             
           
           
            }
           
         
          }
        } else {
          if (el.leafs.length > 0) {
            this.findproductList(code, el.leafs);
          }
        }
        // if (code === el.id) {
        //   this.$emit("selectItem", el.id, el.data.name, null, false);
        //   this.productList = productList;
        // } else {
        //   if (el.leafs.length > 0) {
        //     this.findproductList(code, el.leafs);
        //   }
        // }
      });
    },
    getProductList: _.debounce(function(code) {

      if(this.countrycode==27 ||!this.countrycode ){
        this.$Message.error({content: '请选择目的地，且目的地不能是中国', closable: false})
        return
      }
      
      let data = {
        importerID: this.countrycode,
        data: {
          hsCode: code
        }
      };
      this.productReadynew = true;
  
      Vue._api.getHSProductsE(data, {
        success: response => {
          if (response.data.code === 200) {
           
            if (response.data.data && Object.keys(response.data.data).length && response.data.data.hsTree && response.data.data.hsTree.leafs) {
            
              
              if ( response.data.data && response.data.data.hsTree.leafs.length > 1) {
                this.productList = response.data.data.hsTree.leafs;
              } else {
                this.findproductList(code, response.data.data.hsTree.leafs);
              }
            } else {
              this.productList = [];
            }

            this.productReadynew = false;
          }
        }
      });
    }, 500),
    backDowndown() {
      this.$parent.value = "";
      if (this.productList && this.productList.length > 0) {
        let parentCode = this.productList[0]["pid"];
        if (parentCode === "-1") {
          this.highlightText = "";
          this.$emit("selectItem", "", "", "", false);
        } else {
          this.highlightText = parentCode;
          this.$emit("selectItem", parentCode, "", "", false);
          this.getProductList(parentCode);
        }
      }
    },
    closeDowndown() {
      this.$parent.closeDowndown();
    },
    async selectItem(event, type) {
      let id = this._.trim(event.currentTarget.getAttribute("_id"));
      let name = this._.trim(event.currentTarget.getAttribute("_name"));
      this.highlightText = id;
      this.$emit("selectItem", id, name, null, false);
      if (type && type === "history") {
        this.$emit("selectItem", id, name, null, true);
        this.closeDowndown();
      } else {
        if(id.length==10){
        
        this.$emit(
                "selectItem",
                id,
                name,
                null,
                true
              );
      }
        await this.getProductList(id);
        if (this.productList.length === 1) {
          if (!this.productList[0].leafs.length) {
            this.$emit(
              "selectItem",
              this.productList[0].id,
              this.productList[0].data.name,
              null,
              true
            );
            this.closeDowndown();
          }
        }
      
        let obj = this.productList.find(item=>{
          return item.id == id
        })
        if(obj  && obj.leafs.length==0){
          this.$emit(
              "selectItem",
              obj.id,
              obj.data.name,
              null,
              true
            );
            this.closeDowndown();
        }
      }

      this.scrollToTop();
    },
    scrollToTop() {
      this.$refs.iscroll && this.$refs.iscroll.goToPage(0, 0, 0);
    },
    refresh() {
      this.$refs.iscroll && this.$refs.iscroll.refresh();
    },
    updateContentHeight() {
      let contentEl = this.$refs.autoModContent;
      let dropdownContentHeight = this._h.getOffset(contentEl).height;
      let maxHeight =
        this._h.getWinHeight() -
        (this._h.getScrollTop() + this._h.getOffset(this.$parent.$el).bottom) -
        50;
      maxHeight = this._.max([this.dropDownHeight.maxHeight, maxHeight]);
      this.dropDownHeight.maxHeight = maxHeight;
      this.dropDownHeight.height = this._.min([
        dropdownContentHeight,
        maxHeight
      ]);
    },
    ...mapDataGetters([
      // "getAutoCompleteProduct",
      "getParentByCode",
      "getChildByCode",
      "getIsLastProductByCode",
      "getTopProduct"
    ]),
    highlight(v, k, isStart = false) {
      k = this._.trim(this._.escapeRegExp(k));
      if (!k) return v;
      if (isStart) {
        v = this._.replace(
          v,
          new RegExp(`^${k}`, "i"),
          '<span style="color:#0774b5">$&</span>'
        );
      } else {
        v = this._.replace(
          v,
          new RegExp(`${k}`, "ig"),
          `<span style="color:#0774b5">${k}</span>`
        );
      }
      return v;
    }
  }
};
</script>
<style scoped>
.dropdown {
  position: absolute;
  border: 1px solid #ddd;
  color: #333;
  width: 100%;
  left: 0;
  /*top: 45px;*/
  top: 100%;
  z-index: 1000;
  min-height: 120px;
  background-color: #fff;
  box-shadow: 2px 2px 2px 0 rgba(215, 215, 215, 0.5);
  border-radius: 3px;
  /*font-size: 12px;*/
}
.dropdown-title {
  background-color: #f7f7fb;
  border-radius: 3px;
  height: 28px;
  line-height: 28px;
  position: relative;
}
.back,
.close {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: auto;
  cursor: pointer;
}
.back {
  left: 10px;
  width: 11px;
}
.close {
  right: 10px;
}
.dropdown-content {
  background-color: #fff;
  position: relative;
}
.scroll-view {
  /* -- Attention: This line is extremely important in chrome 55+! -- */
  touch-action: none;
  /* -- Attention-- */
  /*position: fixed;*/
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
ul.list li {
  margin: 8px 0;
  position: relative;
}
ul.list li:first-child {
  margin-top: 0;
}
ul.list li:last-child {
  margin-bottom: 0;
}
ul.list li a {
  color: #151515;
  font-size: 15px;
  display: block;
  text-align: left;
  margin: 0 auto;
  white-space: normal;
}
ul.list li a:hover {
  color: #0774b5;
  text-decoration: none;
  box-shadow: none;
}
ul.list li a:after {
  width: 0;
  height: 0;
}
ul.list li a >>> span.item-code {
  font-size: 1.4rem;
  padding-right: 3px;
}
ul.list li >>> a.item-parent {
  cursor: default;
  color: #999;
  font-size: 1.4rem;
}
ul.list li >>> a.item-parent:hover {
  color: #999;
}
ul.list li.empty {
  text-align: center;
  margin-top: 20px;
}
ul.list li.empty i {
  color: #c1c0c0;
  /*font-size: 12px;*/
  font-size: 14px;
  font-style: italic;
}
.subitem {
  margin-top: 5px;
  margin-left: 12px;
}
.history .title {
  color: #999;
  /*font-size: 1.1rem;*/
  font-size: 1.4rem;
  border-bottom: 1px solid #e9e9e9;
  margin: 12px 0 6px;
  padding-bottom: 3px;
}
.history .list {
  margin-left: 10px;
}
</style>
<style module>
.dropdownContentPadding {
  padding: 8px 18px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProductDropdownE.vue